import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  
  // Click outside ref
  const langMenuRef = useRef<HTMLDivElement>(null);
  
  // Örnek: Oturum açmış kullanıcı kontrolü (gerçek uygulamada kimlik doğrulama servisi kullanılacak)
  const isLoggedIn = false; 

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  // Click outside to close language dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (langMenuRef.current && !langMenuRef.current.contains(event.target as Node)) {
        setIsLangMenuOpen(false);
      }
    };

    if (isLangMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isLangMenuOpen]);

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center">
            <Link to="/" className="text-2xl font-bold text-primary">
              <img src="/images/logo.png" alt="LoloCars" className="h-10 w-auto" />
            </Link>
          </div>

          {/* Main Menu - Desktop */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            <Link to="/" className="px-3 py-2 rounded-md text-sm font-medium text-gray-900 hover:text-primary">
              Home
            </Link>
            <Link to="/cars" className="px-3 py-2 rounded-md text-sm font-medium text-gray-900 hover:text-primary">
              Search Cars
            </Link>
            <Link to="/loan-calculator" className="px-3 py-2 rounded-md text-sm font-medium text-gray-900 hover:text-primary">
              Loan Calculator
            </Link>
            <Link to="/blog" className="px-3 py-2 rounded-md text-sm font-medium text-gray-900 hover:text-primary">
              Car Buying Insights
            </Link>
      
          </div>

          {/* User Menu - Desktop */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            {isLoggedIn ? (
              <>
              <div className="relative">
                <button 
                  onClick={toggleUserMenu}
                  className="flex items-center text-sm font-medium text-gray-900 rounded-full focus:outline-none"
                >
                  <span className="mr-2">My Account</span>
                  <img className="h-8 w-8 rounded-full" src="/images/avatar-placeholder.png" alt="User" />
                </button>
                {/* User Dropdown Menu */}
                {isUserMenuOpen && (
                  <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 z-50">
                    <Link to="/dashboard" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Dashboard
                    </Link>
                    <Link to="/profile" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Profile
                    </Link>
                    <Link to="/my-cars" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      My Cars
                    </Link>
                    <Link to="/my-reservations" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      My Reservations
                    </Link>
                    <button className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
              </>
            ) : (
              <>
                {/* YENİ: WhatsApp Language Support Dropdown */}
                <div className="relative" ref={langMenuRef}>
                  <button
                    className="flex items-center px-3 py-2 rounded-md text-sm font-medium bg-red-600 text-white hover:bg-red-700 focus:outline-none"
                    onClick={() => setIsLangMenuOpen((prev) => !prev)}
                  >
                    {/* WhatsApp Icon */}
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 32 32">
                      <path d="M16 3C9.373 3 4 8.373 4 15c0 2.646.86 5.09 2.32 7.09L4 29l7.18-2.28C13.09 27.14 14.51 27.5 16 27.5c6.627 0 12-5.373 12-12S22.627 3 16 3zm0 22c-1.34 0-2.64-.26-3.84-.76l-.28-.12-4.26 1.36 1.36-4.14-.18-.3C6.7 18.02 6 16.56 6 15c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10zm5.07-7.75c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.44-2.24-1.4-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.42.12-.56.13-.13.29-.34.43-.51.14-.17.18-.29.28-.48.09-.19.05-.36-.02-.51-.07-.15-.62-1.57-.85-2.15-.22-.57-.44-.49-.6-.5-.16-.01-.34-.01-.53-.01-.19 0-.5.07-.76.36-.26.29-.99 1.01-.99 2.46 0 1.45 1.06 2.85 1.21 3.04.15.19 2.09 3.19 5.06 4.35.71.31 1.27.5 1.7.64.71.23 1.36.2 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.28.17-1.41-.08-.13-.28-.2-.59-.35z"/>
                    </svg>
                    Language Support
                    <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {isLangMenuOpen && (
                    <div className="absolute right-0 mt-2 w-56 bg-gray-800 rounded-md shadow-lg py-2 z-50">
                      <a href="https://api.whatsapp.com/send?phone=16478385871" target="_blank" rel="noopener noreferrer" className="flex items-center px-4 py-2 text-white hover:bg-gray-700">
                        <svg className="w-5 h-5 mr-2 text-white" fill="currentColor" viewBox="0 0 32 32">
                          <path d="M16 3C9.373 3 4 8.373 4 15c0 2.646.86 5.09 2.32 7.09L4 29l7.18-2.28C13.09 27.14 14.51 27.5 16 27.5c6.627 0 12-5.373 12-12S22.627 3 16 3zm0 22c-1.34 0-2.64-.26-3.84-.76l-.28-.12-4.26 1.36 1.36-4.14-.18-.3C6.7 18.02 6 16.56 6 15c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10zm5.07-7.75c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.44-2.24-1.4-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.42.12-.56.13-.13.29-.34.43-.51.14-.17.18-.29.28-.48.09-.19.05-.36-.02-.51-.07-.15-.62-1.57-.85-2.15-.22-.57-.44-.49-.6-.5-.16-.01-.34-.01-.53-.01-.19 0-.5.07-.76.36-.26.29-.99 1.01-.99 2.46 0 1.45 1.06 2.85 1.21 3.04.15.19 2.09 3.19 5.06 4.35.71.31 1.27.5 1.7.64.71.23 1.36.2 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.28.17-1.41-.08-.13-.28-.2-.59-.35z"/>
                        </svg>
                        Türkçe Dil Destek
                      </a>
                      <a href="https://api.whatsapp.com/send?phone=14383657070" target="_blank" rel="noopener noreferrer" className="flex items-center px-4 py-2 text-white hover:bg-gray-700">
                        <svg className="w-5 h-5 mr-2 text-white" fill="currentColor" viewBox="0 0 32 32">
                          <path d="M16 3C9.373 3 4 8.373 4 15c0 2.646.86 5.09 2.32 7.09L4 29l7.18-2.28C13.09 27.14 14.51 27.5 16 27.5c6.627 0 12-5.373 12-12S22.627 3 16 3zm0 22c-1.34 0-2.64-.26-3.84-.76l-.28-.12-4.26 1.36 1.36-4.14-.18-.3C6.7 18.02 6 16.56 6 15c0-5.52 4.48-10 10-10s10 4.48 10 10-4.48 10-10 10zm5.07-7.75c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.44-2.24-1.4-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.42.12-.56.13-.13.29-.34.43-.51.14-.17.18-.29.28-.48.09-.19.05-.36-.02-.51-.07-.15-.62-1.57-.85-2.15-.22-.57-.44-.49-.6-.5-.16-.01-.34-.01-.53-.01-.19 0-.5.07-.76.36-.26.29-.99 1.01-.99 2.46 0 1.45 1.06 2.85 1.21 3.04.15.19 2.09 3.19 5.06 4.35.71.31 1.27.5 1.7.64.71.23 1.36.2 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.28.17-1.41-.08-.13-.28-.2-.59-.35z"/>
                        </svg>
                        Hablamos Español
                      </a>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {/* Icon when menu is closed */}
              <svg
                className={`${isMobileMenuOpen ? 'hidden' : 'block'} h-6 w-6`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              {/* Icon when menu is open */}
              <svg
                className={`${isMobileMenuOpen ? 'block' : 'hidden'} h-6 w-6`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`${isMobileMenuOpen ? 'block' : 'hidden'} md:hidden`}>
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          <Link 
            to="/" 
            className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50"
          >
            Home
          </Link>
          <Link 
            to="/cars" 
            className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50"
          >
            Search Cars
          </Link>
          <Link 
            to="/loan-calculator" 
            className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50"
          >
            Loan Calculator
          </Link>
          <Link
            to="/blog"
            className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50"
          >
            Car Buying Insights
          </Link>
     
          
          {/* User links for mobile */}
          {isLoggedIn ? (
            <>
              <div className="border-t border-gray-200 pt-4 mt-4">
                <div className="flex items-center px-3">
                  <div className="flex-shrink-0">
                    <img className="h-10 w-10 rounded-full" src="/images/avatar-placeholder.png" alt="User" />
                  </div>
                  <div className="ml-3">
                    <div className="text-base font-medium text-gray-800">User Name</div>
                    <div className="text-sm font-medium text-gray-500">user@example.com</div>
                  </div>
                </div>
                <div className="mt-3 px-2 space-y-1">
                  <Link 
                    to="/dashboard" 
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50"
                  >
                    Dashboard
                  </Link>
                  <Link 
                    to="/profile" 
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50"
                  >
                    Profile
                  </Link>
                  <Link 
                    to="/my-cars" 
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50"
                  >
                    My Cars
                  </Link>
                  <Link 
                    to="/my-reservations" 
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50"
                  >
                    My Reservations
                  </Link>
                  <button 
                    className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50"
                  >
                    Sign Out
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div className="mt-4">
              <button 
                className="flex items-center w-full px-3 py-2 rounded-md text-base font-medium bg-red-600 text-white hover:bg-red-700 focus:outline-none" 
                                 onClick={() => setIsLangMenuOpen((prev) => !prev)}
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.967-.273-.099-.472-.148-.67.15-.198.297-.767.966-.94 1.164-.173.198-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51-.173-.007-.372-.009-.571-.009-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.099 3.2 5.077 4.363.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.288.173-1.413-.074-.124-.272-.198-.57-.347z" />
                </svg>
                Language Support
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {isLangMenuOpen && (
                <div className="mt-2 space-y-2">
                  <a href="https://api.whatsapp.com/send?phone=16478385871" target="_blank" rel="noopener noreferrer" className="flex items-center w-full px-4 py-2 text-gray-800 bg-white rounded hover:bg-gray-100">
                    <svg className="w-4 h-4 mr-2 text-black" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.967-.273-.099-.472-.148-.67.15-.198.297-.767.966-.94 1.164-.173.198-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51-.173-.007-.372-.009-.571-.009-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.099 3.2 5.077 4.363.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.288.173-1.413-.074-.124-.272-.198-.57-.347z" />
                    </svg>
                    Türkçe Dil Destek
                  </a>
                  <a href="https://api.whatsapp.com/send?phone=14383657070" target="_blank" rel="noopener noreferrer" className="flex items-center w-full px-4 py-2 text-gray-800 bg-white rounded hover:bg-gray-100">
                    <svg className="w-4 h-4 mr-2 text-black" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.967-.273-.099-.472-.148-.67.15-.198.297-.767.966-.94 1.164-.173.198-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51-.173-.007-.372-.009-.571-.009-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.099 3.2 5.077 4.363.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.288.173-1.413-.074-.124-.272-.198-.57-.347z" />
                    </svg>
                    Hablamos Español
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 